var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnAuthenticateRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 5.25,
    stroke: "#DB0046",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 1.5,
    fill: "#DB0046"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5V8.5",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V4C11 2.34315 9.65685 1 8 1V1C6.34315 1 5 2.34315 5 4V6",
    stroke: "#DB0046",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnAuthenticateRed);
export default __webpack_public_path__ + "static/media/icn_btn_authenticate_red.ef188f97abce63c2145c6f1ca3bcaae7.svg";
export { ForwardRef as ReactComponent };